"use client";

import Customers from "@/components/home/customers";
import Header from "@/components/home/header";
import Testimonies from "@/components/home/testimonies";

function Separator() {
  return <div className="w-[80%] py-[1px] bg-gray-500" />;
}

export default function Home() {
  return (
    <div className="flex flex-col items-center justify-between gap-10">
      <Header />
      <Separator />
      <Customers />
      <Separator />
      <Testimonies />
    </div>
  );
}
